import config from '@/config';
import api from '@/shared/api';
// Dedupe concurrent requests; no stale cache because reasons can be added or disabled
// in the settings while the app is running.
let inFlight = null;
// Returns every reason, including the disabled ones: a reason can be disabled after it
// was assigned to a credit note, and that value must still resolve on the invoice.
export const getCreditNoteReasons = () => {
    if (inFlight)
        return inFlight;
    inFlight = api.base
        .get(`${config.appUrls.api}/api/CreditNoteReason/GetAll`)
        .then(({ data }) => data || [])
        .finally(() => {
        inFlight = null;
    });
    return inFlight;
};
export default {
    getCreditNoteReasons,
};
